module.exports = __webpack_public_path__ + "img/0b8b48d.png";